import _ from "lodash";
import router from '@/router'

const state = {
  markets: {},
  odds: {},
  sports: [],
  sportFilter: {},
}
const getters = {
  markets(state) {
    return state.markets
  },
  odds(state) {
    return state.odds
  },
  sports(state) {
    return state.sports
  },
  sportFilter: (state) => (sport_id) => {
    if(!state.sports) return false;
    var sport = _.first(_.filter(state.sports, function(o) { return o.id == sport_id; }));
    return !_.isNull(sport) && !_.isEmpty(sport) && !_.isUndefined(sport.market_id) ? sport.market_id : null;
  },
}
const mutations = {
  SET_MARKETS(state, payLoad){
    state.markets = payLoad;
  },
  SET_ODDS(state, payLoad){
    state.odds = payLoad;
  },
  SET_SPORTS(state, payLoad){
    state.sports = payLoad;
  },
}
const actions = {
  fetchMarkets({ commit, dispatch, state}, payLoad){
    axios.get('/sportsbook/translate/markets').then((response) => {
      commit('SET_MARKETS', response.data)
    })
    .catch((c) => {
      commit('SET_MARKETS', null);
    })
    .finally((f) => { 
    })
  },
  fetchOdds({ commit, dispatch, state}, payLoad){
    axios.get('/sportsbook/translate/odds').then((response) => {
      commit('SET_ODDS', response.data)
    })
    .catch((c) => {
      commit('SET_ODDS', null);
    })
    .finally((f) => { 
    })
  },
  fetchSports({ commit, dispatch, state}, payLoad){
    axios.get('/sportsbook/translate/sports').then((response) => {
      commit('SET_SPORTS', response.data)
    })
    .catch((c) => {
      commit('SET_SPORTS', null);
    })
    .finally((f) => { 
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}